import {Component, Input, OnInit} from '@angular/core';
import { Listing } from '../../../classes/listing';
import { PreferencesService } from '../../../services/preferences.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-remax-radar',
  templateUrl: './remax-radar.component.html',
  styleUrls: ['./remax-radar.component.scss']
})

export class RemaxRadarComponent extends HasSubscriptions implements OnInit {
  @Input() listing: Listing;
  shouldShowSavedSearchModal: boolean = false;
  showSaveSearchModal: boolean = false;
  showNoSavedSearchFound: boolean = false;
  isRadarCTASubmitted: boolean = false;
  numberOfSavedSearches: number = -1;

  constructor(private _preferencesService: PreferencesService,
    private communicationService: CommunicationService){
    super();
  };

  ngOnInit() {
    this.addSub(this._preferencesService.savedSearchesChanged.subscribe((s) => {
      if(this.numberOfSavedSearches != -1 && this.numberOfSavedSearches < s.length)
      {
        this.isRadarCTASubmitted = true
      }
      else
      {
        this.numberOfSavedSearches = s.length;
      }
    }));
  }
  hideSearchPopup() {
    this.showSaveSearchModal = false;
  }
  onSaveSearchClick() {
    this.communicationService.toolbar.saveSearchRequested.next();
  }
}
